(() => {
  const root = document.querySelector('[data-combo-page]');
  if (!root) return;

  const max = Number(root.dataset.max || 3);
  const discountPercent = Number(root.dataset.discount || 20);
  const cards = [...root.querySelectorAll('[data-combo-card]')];
  const grid = root.querySelector('[data-combo-grid]');
  const search = root.querySelector('[data-combo-search]');
  const categoryDesktop = root.querySelector('[data-combo-category]');
  const categoryMobile = root.querySelector('[data-combo-category-mobile]');
  const sortDesktop = root.querySelector('[data-combo-sort]');
  const sortMobile = root.querySelector('[data-combo-sort-mobile]');
  const noResults = root.querySelector('[data-combo-no-results]');
  const selected = new Map();
  const params = new URLSearchParams(window.location.search);
  const editComboId = params.get('edit_combo') || '';
  const editVariantIds = (params.get('variants') || '').split(',').map(id => id.trim()).filter(Boolean);
  const isEditing = Boolean(editComboId);
  let adding = false;

  if (isEditing) root.classList.add('is-editing');

  const money = cents => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100);

  const categories = [...new Set(cards.map(card => card.dataset.category).filter(Boolean))].sort((a,b) => a.localeCompare(b));
  [categoryDesktop, categoryMobile].filter(Boolean).forEach(select => {
    categories.forEach(category => {
      const option = document.createElement('option');
      option.value = category;
      option.textContent = category;
      select.appendChild(option);
    });
  });

  function selectedData(card) {
    return {
      id: card.dataset.variantId,
      title: card.dataset.title,
      price: Number(card.dataset.price || 0),
      image: card.dataset.image || ''
    };
  }

  function syncSelects(source, targets) {
    targets.filter(Boolean).forEach(target => { if (target !== source) target.value = source.value; });
  }

  function applyFilters() {
    const query = (search?.value || '').trim().toLowerCase();
    const category = categoryDesktop?.value || categoryMobile?.value || 'all';
    const sort = sortDesktop?.value || sortMobile?.value || 'featured';

    const sorted = [...cards].sort((a, b) => {
      if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort === 'name-asc') return a.dataset.title.localeCompare(b.dataset.title);
      return Number(a.dataset.index) - Number(b.dataset.index);
    });

    sorted.forEach(card => grid?.appendChild(card));
    let visible = 0;
    cards.forEach(card => {
      const matchesSearch = !query || card.dataset.title.toLowerCase().includes(query);
      const matchesCategory = category === 'all' || card.dataset.category === category;
      const show = matchesSearch && matchesCategory;
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (noResults) noResults.hidden = visible !== 0 || cards.length === 0;
  }

  search?.addEventListener('input', applyFilters);
  categoryDesktop?.addEventListener('change', e => { syncSelects(e.currentTarget, [categoryMobile]); applyFilters(); });
  categoryMobile?.addEventListener('change', e => { syncSelects(e.currentTarget, [categoryDesktop]); applyFilters(); });
  sortDesktop?.addEventListener('change', e => { syncSelects(e.currentTarget, [sortMobile]); applyFilters(); });
  sortMobile?.addEventListener('change', e => { syncSelects(e.currentTarget, [sortDesktop]); applyFilters(); });

  function createSelectedRow(item, target) {
    const row = document.createElement('div');
    row.className = 'combo-page__selected-item';

    let visual;
    if (item.image) {
      visual = document.createElement('img');
      visual.src = item.image;
      visual.alt = item.title;
      visual.loading = 'lazy';
    } else {
      visual = document.createElement('span');
      visual.className = 'combo-page__selected-thumb';
      visual.textContent = '100g';
    }

    const copy = document.createElement('div');
    copy.className = 'combo-page__selected-copy';
    const title = document.createElement('strong');
    title.textContent = item.title;
    const weight = document.createElement('span');
    weight.textContent = '100g';
    copy.append(title, weight);

    const price = document.createElement('strong');
    price.className = 'combo-page__selected-price';
    price.textContent = money(item.price);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'combo-page__remove';
    remove.setAttribute('aria-label', `Remove ${item.title}`);
    remove.textContent = '×';
    remove.addEventListener('click', () => {
      selected.delete(String(item.id));
      render();
    });

    row.append(visual, copy, price, remove);
    target.appendChild(row);
  }

  function setText(selector, value) {
    root.querySelectorAll(selector).forEach(el => { el.textContent = value; });
  }

  function setDisabled(selector, disabled) {
    root.querySelectorAll(selector).forEach(el => { el.disabled = disabled || adding; });
  }

  function renderActionLabels() {
    const cartLabel = adding ? (isEditing ? 'Updating...' : 'Adding...') : (isEditing ? 'Update Combo' : 'Add to Cart');
    const buyLabel = adding ? (isEditing ? 'Updating...' : 'Adding...') : (isEditing ? 'Update & Buy Now' : 'Buy Now');
    setText('[data-combo-cart],[data-combo-cart-mobile]', cartLabel);
    setText('[data-combo-buy],[data-combo-buy-mobile]', buyLabel);
  }

  function render() {
    const items = [...selected.values()];
    const count = items.length;
    const subtotal = items.reduce((sum, item) => sum + item.price, 0);
    const unlocked = count === max;
    const discount = unlocked ? Math.round(subtotal * discountPercent / 100) : 0;
    const total = subtotal - discount;

    cards.forEach(card => {
      const id = String(card.dataset.variantId);
      const active = selected.has(id);
      const available = card.dataset.available === 'true';
      const button = card.querySelector('[data-combo-add-product]');
      card.classList.toggle('is-selected', active);
      if (button) {
        button.disabled = adding || (!available && !active) || (!active && count >= max);
        button.textContent = active ? 'Selected ✓' : !available ? 'Sold Out' : count >= max ? 'Combo Full' : 'Add';
      }
    });

    setText('[data-combo-hero-count]', count);
    setText('[data-combo-count]', count);
    setText('[data-combo-sheet-count]', count);
    setText('[data-combo-mobile-count]', count);
    setText('[data-combo-items-count]', count);
    setText('[data-combo-items-count-mobile]', count);
    setText('[data-combo-subtotal]', money(subtotal));
    setText('[data-combo-subtotal-mobile]', money(subtotal));
    setText('[data-combo-discount]', `−${money(discount)}`);
    setText('[data-combo-discount-mobile]', `−${money(discount)}`);
    setText('[data-combo-total]', money(total));
    setText('[data-combo-total-mobile]', money(total));
    setText('[data-combo-mobile-total]', money(total));
    setText('[data-combo-saving]', `You Save ${money(discount)}`);
    setText('[data-combo-saving-mobile]', `You Save ${money(discount)}`);

    const remaining = Math.max(0, max - count);
    const unlockMessage = unlocked ? `${discountPercent}% OFF unlocked` : `Select ${remaining} more to unlock ${discountPercent}% OFF`;
    root.querySelectorAll('[data-combo-unlock],[data-combo-unlock-mobile]').forEach(el => {
      el.textContent = unlockMessage;
      el.classList.toggle('is-unlocked', unlocked);
    });

    const desktopList = root.querySelector('[data-combo-selected-list]');
    const mobileList = root.querySelector('[data-combo-selected-list-mobile]');
    [desktopList, mobileList].filter(Boolean).forEach(list => {
      list.replaceChildren();
      items.forEach(item => createSelectedRow(item, list));
    });

    root.querySelectorAll('[data-combo-empty-selection],[data-combo-empty-selection-mobile]').forEach(el => { el.hidden = count > 0; });
    setDisabled('[data-combo-cart],[data-combo-buy],[data-combo-cart-mobile],[data-combo-buy-mobile]', !unlocked);
    renderActionLabels();

    if (unlocked && !isEditing && window.matchMedia('(max-width: 767px)').matches && !root.dataset.autoOpened) {
      root.dataset.autoOpened = 'true';
      window.setTimeout(openMobileSummary, 180);
    }
    if (!unlocked) delete root.dataset.autoOpened;
  }

  cards.forEach(card => {
    card.querySelector('[data-combo-add-product]')?.addEventListener('click', () => {
      const id = String(card.dataset.variantId);
      if (selected.has(id)) selected.delete(id);
      else if (selected.size < max && card.dataset.available === 'true') selected.set(id, selectedData(card));
      render();
    });
  });

  const mobileSheet = root.querySelector('[data-combo-mobile-sheet]');
  const filterSheet = root.querySelector('[data-combo-filter-sheet]');
  function openSheet(sheet) {
    if (!sheet) return;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (!mobileSheet?.classList.contains('is-open') && !filterSheet?.classList.contains('is-open')) document.body.style.overflow = '';
  }
  function openMobileSummary() { openSheet(mobileSheet); }

  root.querySelector('[data-combo-mobile-open]')?.addEventListener('click', openMobileSummary);
  root.querySelectorAll('[data-combo-mobile-close]').forEach(btn => btn.addEventListener('click', () => closeSheet(mobileSheet)));
  root.querySelector('[data-combo-filter-open]')?.addEventListener('click', () => openSheet(filterSheet));
  root.querySelectorAll('[data-combo-filter-close]').forEach(btn => btn.addEventListener('click', () => closeSheet(filterSheet)));
  root.querySelector('[data-combo-filter-apply]')?.addEventListener('click', () => { applyFilters(); closeSheet(filterSheet); });
  root.querySelector('[data-combo-clear]')?.addEventListener('click', () => { selected.clear(); render(); });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeSheet(mobileSheet);
    closeSheet(filterSheet);
  });

  async function addCartItems(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error('Unable to add combo');
    return response.json();
  }

  async function replaceExistingCombo(comboId, newItems) {
    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Unable to read cart');
    const cartData = await cartResponse.json();
    const oldItems = cartData.items.filter(item => String(item.properties?._combo_id || '') === comboId);

    if (!oldItems.length) return addCartItems(newItems);

    const updates = {};
    oldItems.forEach(item => { updates[item.key] = 0; });

    const removeResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!removeResponse.ok) throw new Error('Unable to prepare combo update');

    try {
      return await addCartItems(newItems);
    } catch (error) {
      const rollbackItems = oldItems.map(item => {
        const rollbackItem = {
          id: Number(item.variant_id),
          quantity: Number(item.quantity || 1),
          properties: item.properties || {}
        };
        const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
        if (sellingPlanId) rollbackItem.selling_plan = sellingPlanId;
        return rollbackItem;
      });
      try { await addCartItems(rollbackItems); } catch (rollbackError) {}
      throw error;
    }
  }

  async function addCombo(goToCheckout) {
    if (selected.size !== max || adding) return;
    adding = true;
    render();
    const comboId = isEditing ? editComboId : `mewaram-combo-${Date.now()}`;
    const items = [...selected.values()].map(item => ({
      id: Number(item.id),
      quantity: 1,
      properties: {
        'Combo Pack': '100g Gifting Combo',
        '_combo_id': comboId,
        '_combo_discount': `${discountPercent}%`
      }
    }));

    try {
      if (isEditing) await replaceExistingCombo(comboId, items);
      else await addCartItems(items);
      window.location.href = goToCheckout ? '/checkout' : '/cart';
    } catch (error) {
      adding = false;
      render();
      window.alert(isEditing ? 'Could not update this combo. Please try again.' : 'Could not add this combo. Please try again.');
    }
  }

  root.querySelector('[data-combo-cart]')?.addEventListener('click', () => addCombo(false));
  root.querySelector('[data-combo-buy]')?.addEventListener('click', () => addCombo(true));
  root.querySelector('[data-combo-cart-mobile]')?.addEventListener('click', () => addCombo(false));
  root.querySelector('[data-combo-buy-mobile]')?.addEventListener('click', () => addCombo(true));

  if (isEditing && editVariantIds.length) {
    editVariantIds.slice(0, max).forEach(id => {
      const card = cards.find(item => String(item.dataset.variantId) === String(id));
      if (card) selected.set(String(id), selectedData(card));
    });
  }

  applyFilters();
  render();
})();
